import { ref } from 'vue'

/**
 * 助手配置管理
 */
export function useAnalystConfig() {
  const analystMap = ref({
    topicAnalyst: {
      title: '话题分析助手',
      desc: '一键分析销售录音，秒揪产品咨询、砍价、投诉等关键场景，自动输出客户需求与销售漏洞，帮你精准优化话术、提升成单率！',
      roleDefinition:
        '你是专注于销售与客户沟通内容的智能分析助手，能快速识别产品咨询、价格谈判等高频对话场景，提取关键信息并结构化输出，为销售话术优化、客户需求挖掘及服务质量提升提供数据支撑。',
      chatTipsList: [
        {
          title: '看下说我们产品不满足的',
          value: `若客户明确表达价格超出预期、预算无法覆盖、要求降价或存在资金压力等表述，认为对价格持负面态度，若没有则根据上下文评估客户提到价格相关话题时的态度。\n按不同的维度分点总结；明细数据以表格形式输出，列举所有提到价格相关话题的客户：客户名称，客户原话，客户的态度是正面/负面的以及评估原因，会话时间，跟进销售`
        },
        {
          title: '找下聊到产品功能话题的客户',
          value: `重点关注会话中是否出现客户明确提出的需求但方当前产品 / 服务无法满足或者完全不匹配，以及无替代方案解决，明确表达无法满足功能点的重要性、反复提及且有交互讨论，最终确认我方无法满足，才可判断为需求匹配异常。否则认为对产品功能有异议。\n按不同的维度分点总结；明细数据以表格形式输出，列举相关的客户：客户名称，客户原话，客户的态度是正面/负面的以及评估原因，会话时间，跟进销售`
        }
      ]
    },
    sellAnalyst: {
      title: '销售成长助手',
      desc: '智能分析销售录音，精准揪出话术短板，量身定制培训方案，帮销售吃透客户需求、快速成单，拉升团队业绩！',
      roleDefinition:
        '你是销售团队的智能培训师，可分析沟通录音，定位话术漏洞与流程缺失，生成个性化提升方案，通过「话术规范性、流程完整性、沟通有效性、客户需求捕捉、软技能表现」多维度考核模型量化销售技能，助力销售快速掌握客户需求捕捉与成单策略。',
      chatTipsList: [
        {
          title: '看一下近期销售与客户沟通的开场白话术',
          value: `分析当前开场白是否包含：礼貌问候 ；清晰公司/身份介绍 ；简明来意说明 ；客户价值引导 。若存在以下问题：缺乏个性化问候（如未提及客户行业/历史互动）；来意说明模糊（如未明确产品匹配点）。需要生成优化建议\n分点总结；明细数据以表格形式输出：客户名称、跟进销售、话术质量、开场白话术、跟进时间、优化建议`
        },
        {
          title: '近期哪些销售有逼单动作，客户的态度怎么样',
          value: `分析维度：\ni. 识别逼单阶段（如初次试探、二次施压、最终成交）\nii. 判断客户态度（积极响应、中性迟疑、消极拒绝），需提供判断依据（如客户明确表示 "下周签约" 为积极，"再考虑" 为中性，"太贵了" 为消极）\niii. 标注逼单策略（限时优惠、竞品对比、案例刺激、风险逆转等）\niv. 分析逼单话术结构完整性（购买信号捕捉→顾虑化解→行动指令→风险保障）。\n分点总结；明细数据以表格形式输出：客户名称、跟进销售、客户态度、逼单策略、逼单话术、跟进时间`
        },
        {
          title: '帮我找下这个月沟通出现价格异议的销售',
          value: `针对本月销售与客户的沟通录音，筛选出客户在对话中明确对价格提出质疑、抱怨、讨价还价或询问价格优惠等涉及价格异议的内容。具体任务如下：\ni. 识别出所有包含价格异议的客户话术。\nii. 记录对应的销售姓名、沟通时间和客户名称\niii. 分析客户价格异议的具体类型（如单纯嫌贵、寻求优惠、对比价格、预算不符等）\niv. 提取销售在面对价格异议时的回应话术，并评估回应的有效性（可从是否解决客户疑虑、是否促成交易等方面简单判断）\nv. 对销售给出改进建议\n分点总结；明细数据以表格形式输出`
        },
        {
          title: '帮我找下这个月沟通出现产品异议的销售',
          value: `对本月销售与客户的沟通录音进行分析，找出客户在对话中对产品的功能、质量、售后服务、竞争力、使用难度等方面提出质疑、疑问或不满的内容，即产品异议。具体要求如下：\ni. 提取所有涉及产品异议的客户话术\nii. 标注对应的销售姓名、沟通时间和客户名称\niii. 明确客户产品异议的具体方面（功能、质量、售后、竞争力、使用难度等）\n iv. 记录销售针对产品异议的回应内容，并分析回应是否准确、专业，是否有效解决了客户的疑虑\nv. 统计每个销售出现产品异议的次数，并按照次数多少进行排序，同时挑选出几个具有代表性的产品异议沟通案例，包括客户问题、销售回应和改进建议。\n分点总结；明细数据以表格形式输出`
        },
        {
          title: '帮我找下这个月沟通出现服务异议的销售',
          value: `请基于本月销售录音，筛选出客户提出「交付时效、售后响应、培训服务、增值服务、服务承诺」相关异议的对话片段，具体任务：\ni. 提取所有涉及服务异议的客户话术\nii. 标注对应的销售姓名、沟通时间和客户名称\niii. 明确客户服务异议的具体方面（交付/售后/培训/增值服务/服务承诺）\n iv. 记录销售针对服务异议的回应内容，并分析回应是否准确、专业，是否有效解决了客户的疑虑\n v. 统计每个销售出现服务异议的次数，并按照次数多少进行排序，同时挑选出几个具有代表性的产品异议沟通案例，包括客户问题、销售回应和改进建议。\n分点总结；明细数据以表格形式输出`
        }
      ]
    }
  })

  // 默认AI助手
  const defaultAssistant = 'topicAnalyst'

  // 根据路由获取助手ID
  const getAssistantId = (route) => {
    const assistantIdMap = {
      topicAnalyst: '4',
      sellAnalyst: '5'
    }
    return assistantIdMap[route?.meta?.type || defaultAssistant]
  }

  // 获取当前助手配置信息
  const getCurrentAnalyst = (route) => {
    const type = route?.meta?.type || defaultAssistant
    return analystMap.value[type]
  }

  // 获取推荐模版列表
  const getChatTipsList = (route) => {
    const analyst = getCurrentAnalyst(route)
    return analyst.chatTipsList || []
  }

  return {
    analystMap,
    getAssistantId,
    getCurrentAnalyst,
    getChatTipsList
  }
}
